export function ProgressBar({ current, max }: { current: number; max: number }) {
  return (
    <div className="bg-slate-200 rounded h-1 overflow-hidden my-1.5">
      <div
        className="h-full bg-primary-500 rounded transition-all duration-300"
        style={{ width: `${Math.min((current / max) * 100, 100)}%` }}
      />
    </div>
  );
}
